import img1 from "../../images/cypto.png";
import img2 from "../../images/solme.png";
import img3 from "../../images/reveel.png";
import img6 from "../../images/shomium.png";
import img7 from "../../images/pay.png";
import img8 from "../../images/oneDollar.PNG";
import img9 from "../../images/memories.png";
import img10 from "../../images/trade.png";
import img11 from "../../images/pizza.png";
import img12 from "../../images/dark.PNG";
import img13 from "../../images/dogs.png";
import img14 from "../../images/reward.png";
import img15 from "../../images/sch.png";
import img16 from "../../images/business.png";
import img17 from "../../images/pension.png";
import img18 from "../../images/cloud.png";

export const nftProjects = [
  {
    id: 1,
    img: img13,
    title: "Bored Dogs",
    info: "React, Tailwind css",
    site: "https://bored-dogs.netlify.app/",
  },
  {
    id: 2,
    img: img12,
    title: "Dark Eye",
    info: "React, Tailwind css",
    site: "https://dark-eyes.netlify.app/",
  },
  {
    id: 3,
    img: img1,
    title: "Crypto clones",
    info: "React, Tailwind css",
    site: "https://crypto-clonee.netlify.app/",
  },
  {
    id: 4,
    img: img2,
    title: "solmekkas",
    info: "React, Tailwind css",
    site: "https://solmekass.netlify.app/",
  },
];

export const tailwindProjects = [
  {
    id: 1,
    img: img18,
    title: "Cloudsail",
    info: "Next js, Tailwind css",
    site: "https://cloudsail.vercel.app/",
  },
  {
    id: 2,
    img: img14,
    title: "Reward Miner",
    info: "React, Tailwind css",
    site: "https://reward-minerr.netlify.app/",
  },
  {
    id: 3,
    img: img17,
    title: "Pension Consultants",
    info: "React, Tailwind css",
    site: "https://pension-consultants.netlify.app/",
  },
  {
    id: 4,
    img: img3,
    title: "Reveel",
    info: "React, Tailwind css",
    site: "https://reveel-web.netlify.app/",
  },
  {
    id: 5,
    img: img15,
    title: "Schmitz Portfolio",
    info: "React, Tailwind css",
    site: "https://schmitz-portfolio.netlify.app/",
  },
  {
    id: 6,
    img: img16,
    title: "business online",
    info: "React, Tailwind css",
    site: "https://businesz-online.netlify.app/",
  },
];

export const otherProjects = [
  {
    id: 1,
    img: img6,
    title: "Shomium",
    info: "React, React-bootstrap",
    site: "https://shomium.netlify.app/",
  },
  {
    id: 2,
    img: img7,
    title: "pay mercury",
    info: "React, Css, Scss, bootstrap",
    site: "https://pay-mercury.netlify.app/",
  },
  {
    id: 3,
    img: img8,
    title: "One Dollar Finance",
    info: "React, react-bootstrap",
    site: "https://one-dollar-finance.netlify.app/",
  },
  {
    id: 4,
    img: img9,
    title: "Create Your Memories",
    info: "Mongodb, express, react, node, mui",
    site: "https://create-your-memories.netlify.app/",
  },
  {
    id: 5,
    img: img10,
    title: "We Trade Daily",
    info: "React, react-bootstrap",
    site: "https://wetradedaily.netlify.app/",
  },
  {
    id: 6,
    img: img11,
    title: "pizza Fun",
    info: "React, Css, Framer Motion",
    site: "https://pizza-fun.netlify.app",
  },
];
